import { lazy, Suspense } from 'react';
import './global.css';
import './table.css'
import './pages/store/contentBlocks/contentBlocks.css';
import './pages/store/contentBlocks/Details.css';
import './pages/store/contentBlocks/contentBlocks-add-forms.css';
import {Route, Routes, Outlet, Navigate} from 'react-router-dom';
import {useSortableTableData} from "./Utils/SortableTableData.js";
import AuthRoutes from "./pages/Auth/AuthRoutes";
import ProtectedRoute from './ProtectedRoute';
import {useAuth} from './context/AuthContext';
import ScrollToTop from "./Utils/ScrollToTop";
import Provider from "./Utils/Provider.js";
import LoadingSpinner from "./components/LoadingSpinner/LoadingSpinner.js";
import { RequirePermission } from './components/RequirePermission/RequirePermission.jsx';
import FlashToastHost from './components/Toast/FlashToastHost.jsx';
import PageViewBeacon from './analytics/PageViewBeacon.jsx';
const Layout = lazy(() => import("./components/Layout/Layout.js"));
const AccountSettingsLayout = lazy(() => import("./components/Layout/AccountSettingsLayout/index.js"),);
const Home = lazy(() => import("./pages/Home/Home.jsx"));
const Products = lazy(() => import("./pages/Retail/Products/ProductList.jsx"));
const Properties = lazy(() => import("./pages/RealEstate/Properties/Properties.jsx"));
const Cars = lazy(() => import("./pages/Automotive/Cars/Cars.jsx"));
const AddCar = lazy(() => import("./pages/Automotive/Cars/Add&EditCar/AddCar.jsx"));
const EditCar = lazy(() => import("./pages/Automotive/Cars/Add&EditCar/EditCar.jsx"));
const AddProperty = lazy(() => import("./pages/RealEstate/Properties/Add&EditProperty/AddProperty.jsx"));
const ViewProperty = lazy(() => import("./pages/RealEstate/Properties/ViewProperty/ViewProperty.jsx"));
const EditProperty = lazy(() => import("./pages/RealEstate/Properties/Add&EditProperty/EditProperty.jsx"));
const AppUsers = lazy(() => import("./pages/AppUser/AppUsers.jsx"));
const RegisterAppUser = lazy(() => import("./pages/AppUser/RegisterAppUsers/./RegisterAppUser"));
const AppUserDetails = lazy(() => import("./pages/AppUser/AppUserDetails/./AppUserDetails"));
const AccountSetting = lazy(() => import("./pages/Settings/AccountSettings/AccountSetting"));
const PlatformOrganizations = lazy(() => import("./pages/Platform/PlatformOrganizations.jsx"));
const OpeningHours = lazy(() => import("./pages/store/StoreSetting/OpeningHours/OpeningHours"));
const StoreDomains = lazy(() => import("./pages/store/StoreSetting/StoreDomains/StoreDomains.jsx"));
const StorePayments = lazy(() => import("./pages/store/StoreSetting/StorePayments/StorePayments.jsx"));
const StoreQr = lazy(() => import("./pages/store/StoreQr/StoreQr.jsx"));
const ManageStore = lazy(() => import("./pages/store/StoreSetting/ManageStore/ManageStore.jsx"));
const OnlineStore = lazy(() => import("./pages/store/OnlineStore/OnlineStore.jsx"));
const StorefrontPages = lazy(() => import("./pages/store/StorefrontPages/StorefrontPages.jsx"));
const ThemeEditor = lazy(() => import("./pages/store/ThemeEditor/ThemeEditor.jsx"));
const AddPItem = lazy(() => import("./pages/Retail/Products/addProduct/AddProduct"));
const EditProduct = lazy(() => import("./pages/Retail/Products/editProduct/editProduct"));
const MenuList = lazy(() => import("./pages/Resturant/Menu/menu.jsx"));
const AddMenu = lazy(() => import("./pages/Resturant/Menu/AddMenu/addMenu.jsx"));
const EditMenu = lazy(() => import("./pages/Resturant/Menu/EditMenu/editMenu.jsx"));
const ViewMenu = lazy(() => import("./pages/Resturant/Menu/ViewMenu/viewMenu.jsx"));
const ContentBlocks = lazy(() => import("./pages/store/contentBlocks/contentBlocks"));
const HeroSectionItem = lazy(() => import("./pages/store/contentBlocks/Hero/HeroItem.js"));
const HeroDetails = lazy(() => import("./pages/store/contentBlocks/Hero/HeroDetails"));
const AddHero = lazy(() => import("./pages/store/contentBlocks/Hero/AddHero.js"));
const BannerItem = lazy(() => import("./pages/store/contentBlocks/Banner/BannerItem"));
const BannerDetail = lazy(() => import("./pages/store/contentBlocks/Banner/BannerDetails"));
const BannerAdd = lazy(() => import("./pages/store/contentBlocks/Banner/BannerAdd"));
const PhotoGalleryAdd = lazy(() => import("./pages/store/contentBlocks/photoGallery/photoGalleryAdd"));
const PhotoGalleryDetail = lazy(() => import("./pages/store/contentBlocks/photoGallery/photoGalleryDetails"));
const AdminManagement = lazy(() => import("./pages/AdminManagement/AdminManagement"));
const RegisterAdmin = lazy(() => import("./pages/AdminManagement/RegisterAdmin/RegisterAdmin.jsx"));
const AdminDetails = lazy(() => import("./pages/AdminManagement/AdminDetails/AdminDetails.jsx"));
const Notifications = lazy(() => import("./pages/Notifications/Notifications"));
const Chat = lazy(() => import("./pages/Chat/Chat.jsx"));
const SupportInbox = lazy(() => import("./pages/SupportInbox/SupportInbox.jsx"));
const Gallery = lazy(() => import("./pages/store/contentBlocks/photoGallery/GalleryItem"));
const TestimonialsItem = lazy(() => import("./pages/store/contentBlocks/Testimonials/TestimonialsItem.js"));
const TestimonialAdd = lazy(() => import("./pages/store/contentBlocks/Testimonials/TestimonialAdd.js"));
const TestimonialDetails = lazy(() => import("./pages/store/contentBlocks/Testimonials/TestimonialDetails.js"));
const FaqItem = lazy(() => import("./pages/store/contentBlocks/Faq/FaqItem.js"));
const FaqAdd = lazy(() => import("./pages/store/contentBlocks/Faq/FaqAdd.js"));
const FaqDetails = lazy(() => import("./pages/store/contentBlocks/Faq/FaqDetails.js"));
const EventItem = lazy(() => import("./pages/store/contentBlocks/Events/EventItem.js"));
const EventAdd = lazy(() => import("./pages/store/contentBlocks/Events/EventAdd.js"));
const EventDetails = lazy(() => import("./pages/store/contentBlocks/Events/EventDetails.js"));
const Analytics = lazy(() => import("./pages/Analytics/Analytics"));
const FoodOrderList = lazy(() => import("./pages/Resturant/FoodOrders/FoodOrders.jsx"));
const TodayFoodOrders = lazy(() => import("./pages/Resturant/FoodOrders/./TodayFoodOrders"));
const FoodOrderDetails = lazy(() => import("./pages/Resturant/FoodOrders/FoodOrdersDetails/FoodOrderDetails.jsx"));
const ContactMessages = lazy(() => import("./pages/Customer/ContactMessages/ContactMessages.jsx"));
const ContactMessageDetails = lazy(() => import("./pages/Customer/ContactMessages/ContactMessageDetails/ContactMessageDetails.jsx"));
const Reservations = lazy(() => import("./pages/Customer/Reservations/Reservations.jsx"));
const ReservationFloorPlan = lazy(() => import("./pages/Customer/Reservations/FloorPlan.jsx"));
const ReservationDetails = lazy(() => import("./pages/Customer/Reservations/ReservationDetails.jsx"));
const Subscribers = lazy(() => import("./pages/Customer/Subscribers/Subscribers.jsx"));
const SubscriberDetails = lazy(() => import("./pages/Customer/Subscribers/SubscriberDetails/SubscriberDetails.jsx"));
const SendNewsletter = lazy(() => import("./pages/Customer/Subscribers/SendNewsletter/SendNewsletter.jsx"));
const LoginAttempts = lazy(() => import("./pages/Security/LoginAttempts.jsx"));
const MandatoryPasswordChange = lazy(() => import("./pages/Security/MandatoryPasswordChange.jsx"));
const SelectStore = lazy(() => import("./pages/SelectStore/SelectStore/SelectStore.jsx"));
const SelectPlan = lazy(() => import("./pages/SelectPlan/SelectPlan.jsx"));
const CheckoutPage = lazy(() => import("./pages/SelectPlan/CheckoutPage.jsx"));
const CheckoutLegacyRedirect = lazy(() => import("./pages/SelectPlan/CheckoutLegacyRedirect.jsx"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
const Test = lazy(() => import("./pages/store/StoreSetting/test.jsx"));
const GeneralSettings = lazy(() => import("./pages/store/StoreSetting/GeneralSettings.js"));
const Coupons = lazy(() => import("./pages/Coupons/Coupons.jsx"));
const ProductOrderList = lazy(() => import("./pages/Retail/ProductOrders/ProductOrders.jsx"));
const TodayProductOrders = lazy(() => import("./pages/Retail/ProductOrders/TodayProductOrders.jsx"));
const ProductOrderDetails = lazy(() => import("./pages/Retail/ProductOrders/ProductOrderDetails/ProductOrderDetails.jsx"));
const Employees = lazy(() => import("./pages/HRMS/Employees/EmployeeList/Employees.jsx"));
const AddEmployee = lazy(() => import("./pages/HRMS/Employees/AddEmployee/AddEmployee.jsx"));
const EditEmployee = lazy(() => import("./pages/HRMS/Employees/EditEmployee/EditEmployee.jsx"));
const EmployeeDetails = lazy(() => import("./pages/HRMS/Employees/EmployeeDetails/EmployeeDetails.jsx"));
const Attendance = lazy(() => import("./pages/HRMS/Attendance/AttendancceList/Attendance.jsx"));
const AddAttendance = lazy(() => import("./pages/HRMS/Attendance/LogAttendance/./LogAttendance"));
const LeaveRequests = lazy(() => import("./pages/HRMS/LeaveRequests/LeaveRequestList/LeaveRequests.jsx"));
const NewLeaveRequestPage = lazy(() => import("./pages/HRMS/LeaveRequests/NewLeaveRequest/NewLeaveRequestPage.jsx"));
const TeamDepartments = lazy(() => import("./pages/HRMS/Departments/Departments.jsx"));
const TeamHolidays = lazy(() => import("./pages/HRMS/Holidays/Holidays.jsx"));
const LeavePolicies = lazy(() => import("./pages/HRMS/LeavePolicies/LeavePolicies.jsx"));
const ShiftTemplates = lazy(() => import("./pages/HRMS/Shifts/ShiftTemplates.jsx"));
const Roster = lazy(() => import("./pages/HRMS/Roster/Roster.jsx"));
const ExpenseClaims = lazy(() => import("./pages/HRMS/Expenses/ExpenseClaims.jsx"));
const TrainingRecords = lazy(() => import("./pages/HRMS/Training/TrainingRecords.jsx"));
const AssetAssignments = lazy(() => import("./pages/HRMS/Assets/AssetAssignments.jsx"));
const Payroll = lazy(() => import("./pages/HRMS/Payroll/Payroll.jsx"));
const HrmsReports = lazy(() => import("./pages/HRMS/Reports/HrmsReports.jsx"));
const HrmsHome = lazy(() => import("./pages/HRMS/HrmsHome/HrmsHome.jsx"));
import {
    adminHasMenuView,
    adminHasMenuManage,
    adminHasContactsView,
    adminHasReservationsView,
    adminHasSubscribersView,
    adminHasSubscribersManage,
    adminHasProductsView,
    adminHasProductsManage,
    adminHasPropertiesView,
    adminHasPropertiesManage,
    adminHasCarsView,
    adminHasCarsManage,
    adminHasFoodOrdersView,
    adminHasProductOrdersView,
    adminHasAppUsersView,
    adminHasAppUsersManage,
    adminHasCouponsView,
    adminHasSettingsView,
    adminHasAdminsView,
    adminHasAdminsManage,
    adminHasSecurityView,
    adminHasAnalyticsView,
    adminHasHeroView,
    adminHasHeroManage,
    adminHasBannerView,
    adminHasBannerManage,
    adminHasPhotoGalleryView,
    adminHasPhotoGalleryManage,
    adminHasTestimonialsView,
    adminHasTestimonialsManage,
    adminHasFaqView,
    adminHasFaqManage,
    adminHasEventsView,
    adminHasEventsManage,
    adminHasContentBlocksHubAccess,
    adminHasTeamView,
    adminHasTeamEmployeesView,
    adminHasTeamEmployeesManage,
    adminHasTeamAttendanceView,
    adminHasTeamAttendanceManage,
    adminHasTeamLeaveRequestsView,
    adminHasTeamLeaveRequestsManage,
} from './Utils/adminPermissions.js';

const ProtectedLayout = () => {
    return (
        <ProtectedRoute>
            <Layout>
                <Outlet/>
            </Layout>
        </ProtectedRoute>
    );
};

/** Authenticated account settings routes — dashboard chrome without the sidebar. */
const ProtectedAccountSettingsLayout = () => {
    return (
        <ProtectedRoute>
            <AccountSettingsLayout>
                <Outlet />
            </AccountSettingsLayout>
        </ProtectedRoute>
    );
};

/** Authenticated routes without dashboard chrome (no header/sidebar). */
const ProtectedStandaloneOutlet = () => (
    <ProtectedRoute>
        <Outlet />
    </ProtectedRoute>
);

const RootRedirect = () => {
    const {isAuthenticated, loading} = useAuth();

    // Prevent redirect until Auth status is known
    if (loading) return <LoadingSpinner />;

    return isAuthenticated
        ? <Navigate to="/home" replace/>
        : <Navigate to="/login" replace/>;
};


function App() {
    return (
        <Provider>
            <ScrollToTop/>
            <PageViewBeacon />
            <FlashToastHost />
            <Suspense fallback={<LoadingSpinner/>}>
                <Routes>
                <Route path="/" element={<RootRedirect/>}/>
                <Route element={<ProtectedStandaloneOutlet />}>
                    <Route path="/password-required" element={<MandatoryPasswordChange />} />
                    <Route path="/select-plan" element={<SelectPlan />} />
                    <Route path="/select-plan/checkout" element={<CheckoutPage />} />
                    <Route path="/select-plan/checkout/card" element={<CheckoutLegacyRedirect />} />
                    <Route path="/select-plan/checkout/crypto" element={<CheckoutLegacyRedirect />} />
                    <Route path="/select-store" element={<SelectStore />} />
                    <Route
                        path="/online-store/theme"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <ThemeEditor />
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/online-store/theme/:themeId"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <ThemeEditor />
                            </RequirePermission>
                        }
                    />
                </Route>
                <Route element={<ProtectedAccountSettingsLayout />}>
                    <Route path="/account-setting" element={<AccountSetting />} />
                </Route>

                {/* Nested Protected Routes */}
                <Route element={
                    <ProtectedLayout/>
                }>
                    <Route path='/test' element={<Test/>}/>

                    <Route
                        path="/home"
                        element={
                            <Home/>
                        }/>

                    <Route
                        path="/food-orders"
                        element={
                            <RequirePermission check={adminHasFoodOrdersView}>
                                <FoodOrderList/>
                            </RequirePermission>
                        }/>

                    <Route
                        path="/items"
                        element={
                            <RequirePermission check={adminHasProductsView}>
                                <Products
                                    SortableTableData={useSortableTableData}
                                />
                            </RequirePermission>
                        }/>

                    <Route
                        path="/properties"
                        element={
                            <RequirePermission check={adminHasPropertiesView}>
                                <Properties />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/properties/add"
                        element={
                            <RequirePermission check={adminHasPropertiesManage}>
                                <AddProperty />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/properties/:id/edit"
                        element={
                            <RequirePermission check={adminHasPropertiesManage}>
                                <EditProperty />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/properties/:id"
                        element={
                            <RequirePermission check={adminHasPropertiesView}>
                                <ViewProperty />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/cars"
                        element={
                            <RequirePermission check={adminHasCarsView}>
                                <Cars />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/cars/add"
                        element={
                            <RequirePermission check={adminHasCarsManage}>
                                <AddCar />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/cars/:id/edit"
                        element={
                            <RequirePermission check={adminHasCarsManage}>
                                <EditCar />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/products/:id/edit"
                        element={
                            <RequirePermission check={adminHasProductsManage}>
                                <EditProduct />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/users"
                        element={
                            <RequirePermission check={adminHasAppUsersView}>
                                <AppUsers/>
                            </RequirePermission>
                        }/>

                    <Route
                        path="/users/register"
                        element={
                            <RequirePermission check={adminHasAppUsersManage}>
                                <RegisterAppUser/>
                            </RequirePermission>
                        }/>

                    <Route
                        path="/users/:id"
                        element={
                            <RequirePermission check={adminHasAppUsersView}>
                                <AppUserDetails/>
                            </RequirePermission>
                        }/>

                    <Route
                        path="/team"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <HrmsHome />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/employees"
                        element={
                            <RequirePermission check={adminHasTeamEmployeesView}>
                                <Employees />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/employees/new"
                        element={
                            <RequirePermission check={adminHasTeamEmployeesManage}>
                                <AddEmployee />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/employees/:id/edit"
                        element={
                            <RequirePermission check={adminHasTeamEmployeesManage}>
                                <EditEmployee />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/employees/:id"
                        element={
                            <RequirePermission check={adminHasTeamEmployeesView}>
                                <EmployeeDetails />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/attendance"
                        element={
                            <RequirePermission check={adminHasTeamAttendanceView}>
                                <Attendance />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/attendance/new"
                        element={
                            <RequirePermission check={adminHasTeamAttendanceManage}>
                                <AddAttendance />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/leave-requests/new"
                        element={
                            <RequirePermission check={adminHasTeamLeaveRequestsManage}>
                                <NewLeaveRequestPage />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/leave-requests"
                        element={
                            <RequirePermission check={adminHasTeamLeaveRequestsView}>
                                <LeaveRequests />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/leave-policies"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <LeavePolicies />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/departments"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <TeamDepartments />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/holidays"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <TeamHolidays />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/shift-templates"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <ShiftTemplates />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/roster"
                        element={
                            <RequirePermission check={adminHasTeamAttendanceView}>
                                <Roster />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/payroll"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <Payroll />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/expenses"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <ExpenseClaims />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/training"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <TrainingRecords />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/assets"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <AssetAssignments />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/team/reports"
                        element={
                            <RequirePermission check={adminHasTeamView}>
                                <HrmsReports />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/platform/organizations"
                        element={<PlatformOrganizations />}
                    />

                    <Route
                        path="/open-hours"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <OpeningHours/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/store-domains"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <StoreDomains/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/store-payments"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <StorePayments/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/store-qr"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <StoreQr/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/manage-store"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <ManageStore/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/online-store"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <OnlineStore/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/storefront-pages"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <StorefrontPages/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/general-settings"
                        element={
                            <RequirePermission check={adminHasSettingsView}>
                                <GeneralSettings/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/coupons"
                        element={
                            <RequirePermission check={adminHasCouponsView}>
                                <Coupons/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/add-new-item"
                        element={
                            <RequirePermission check={adminHasProductsManage}>
                                <AddPItem/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/edit-item/:id"
                        element={
                            <RequirePermission check={adminHasProductsManage}>
                                <EditProduct/>
                            </RequirePermission>
                        }
                    />

                    {/* Menu Management Routes — view_menu (read) vs manage_menu / manage_content (writes) */}
                    <Route
                        path="/menu"
                        element={
                            <RequirePermission check={adminHasMenuView}>
                                <MenuList/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/menu/add"
                        element={
                            <RequirePermission check={adminHasMenuManage}>
                                <AddMenu/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/menu/edit/:id"
                        element={
                            <RequirePermission check={adminHasMenuManage}>
                                <EditMenu/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/menu/view/:id"
                        element={
                            <RequirePermission check={adminHasMenuView}>
                                <ViewMenu/>
                            </RequirePermission>
                        }
                    />

                    {/* admin management */}
                    <Route
                        path="/admins-managements"
                        element={
                            <RequirePermission check={adminHasAdminsView}>
                                <AdminManagement/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/admins-managements/register"
                        element={
                            <RequirePermission check={adminHasAdminsManage}>
                                <RegisterAdmin/>
                            </RequirePermission>
                        }
                    />
                    <Route
                        path="/admins-managements/:id"
                        element={
                            <RequirePermission check={adminHasAdminsView}>
                                <AdminDetails/>
                            </RequirePermission>
                        }
                    />

                    {/* content blocks  */}
                    <Route
                        path="/content-blocks"
                        element={
                            <RequirePermission check={adminHasContentBlocksHubAccess}>
                                <ContentBlocks/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/hero-item"
                        element={
                            <RequirePermission check={adminHasHeroView}>
                                <HeroSectionItem SortableTableData={useSortableTableData}/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/hero-item/hero-details/:id"
                        element={
                            <RequirePermission check={adminHasHeroView}>
                                <HeroDetails SortableTableData={useSortableTableData}/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/hero-item/add-new-item"
                        element={
                            <RequirePermission check={adminHasHeroManage}>
                                <AddHero/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/banner-item"
                        element={
                            <RequirePermission check={adminHasBannerView}>
                                <BannerItem SortableTableData={useSortableTableData}/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/banner-item/add-new-banner"
                        element={
                            <RequirePermission check={adminHasBannerManage}>
                                <BannerAdd SortableTableData={useSortableTableData}/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/banner-details/:id"
                        element={
                            <RequirePermission check={adminHasBannerView}>
                                <BannerDetail SortableTableData={useSortableTableData}/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/photo-gallery"
                        element={
                            <RequirePermission check={adminHasPhotoGalleryView}>
                                <Gallery SortableTableData={useSortableTableData} />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/photo-gallery-add"
                        element={
                            <RequirePermission check={adminHasPhotoGalleryManage}>
                                <PhotoGalleryAdd SortableTableData={useSortableTableData}/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/photo-gallery-details/:id"
                        element={
                            <RequirePermission check={adminHasPhotoGalleryView}>
                                <PhotoGalleryDetail SortableTableData={useSortableTableData}/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/testimonials"
                        element={
                            <RequirePermission check={adminHasTestimonialsView}>
                                <TestimonialsItem />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/testimonials/add"
                        element={
                            <RequirePermission check={adminHasTestimonialsManage}>
                                <TestimonialAdd />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/testimonials/:id"
                        element={
                            <RequirePermission check={adminHasTestimonialsView}>
                                <TestimonialDetails />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/faq"
                        element={
                            <RequirePermission check={adminHasFaqView}>
                                <FaqItem />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/faq/add"
                        element={
                            <RequirePermission check={adminHasFaqManage}>
                                <FaqAdd />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/faq/:id"
                        element={
                            <RequirePermission check={adminHasFaqView}>
                                <FaqDetails />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/events"
                        element={
                            <RequirePermission check={adminHasEventsView}>
                                <EventItem />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/events/add"
                        element={
                            <RequirePermission check={adminHasEventsManage}>
                                <EventAdd />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/content-blocks/events/:id"
                        element={
                            <RequirePermission check={adminHasEventsView}>
                                <EventDetails />
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/notifications"
                        element={
                            <Notifications/>
                        }
                    />

                    <Route
                        path="/chat"
                        element={
                            <Chat/>
                        }
                    />

                    <Route
                        path="/support-inbox"
                        element={
                            <SupportInbox/>
                        }
                    />

                    <Route
                        path="/analytics"
                        element={
                            <RequirePermission check={adminHasAnalyticsView}>
                                <Analytics/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/contact-messages"
                        element={
                            <RequirePermission check={adminHasContactsView}>
                                <ContactMessages/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/contact-messages/:id"
                        element={
                            <RequirePermission check={adminHasContactsView}>
                                <ContactMessageDetails/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/reservations"
                        element={
                            <RequirePermission check={adminHasReservationsView}>
                                <Reservations/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/reservations/floor-plan"
                        element={
                            <RequirePermission check={adminHasReservationsView}>
                                <ReservationFloorPlan/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/reservations/tables"
                        element={<Navigate to="/reservations/floor-plan" replace />}
                    />

                    <Route
                        path="/reservations/:id"
                        element={
                            <RequirePermission check={adminHasReservationsView}>
                                <ReservationDetails/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/subscribers"
                        element={
                            <RequirePermission check={adminHasSubscribersView}>
                                <Subscribers/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/subscribers/send-newsletter"
                        element={
                            <RequirePermission check={adminHasSubscribersManage}>
                                <SendNewsletter/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/subscribers/:id"
                        element={
                            <RequirePermission check={adminHasSubscribersView}>
                                <SubscriberDetails/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/todays-food-orders"
                        element={
                            <RequirePermission check={adminHasFoodOrdersView}>
                                <TodayFoodOrders/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/food-order/:id"
                        element={
                            <RequirePermission check={adminHasFoodOrdersView}>
                                <FoodOrderDetails/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/product-orders"
                        element={
                            <RequirePermission check={adminHasProductOrdersView}>
                                <ProductOrderList/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/todays-product-orders"
                        element={
                            <RequirePermission check={adminHasProductOrdersView}>
                                <TodayProductOrders/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/product-order/:id"
                        element={
                            <RequirePermission check={adminHasProductOrdersView}>
                                <ProductOrderDetails/>
                            </RequirePermission>
                        }
                    />

                    <Route
                        path="/login-security"
                        element={
                            <RequirePermission check={adminHasSecurityView}>
                                <LoginAttempts/>
                            </RequirePermission>
                        }
                    />


                </Route>

                {/* Unauthenticated Routes */}
                {AuthRoutes()}

                {/* 404 Catch-all */}
                <Route path="*" element={<NotFound/>}/>
                </Routes>
            </Suspense>
        </Provider>
    );
}

export default App;
